// extracted by mini-css-extract-plugin
module.exports = {"header":"_56195b5","button":"_a87c607","tickIcon":"_89ab5c2","closeIcon":"_e3b6e30"};